<p-accordion id="tire-storage-info" [activeIndex]="size?.activeIndex">
  <p-accordionTab header="Header {{index}}">
    <p-header>
      <div class="row flex-center-center m-0">
        <div class="col-6 pl-0" *ngIf="!isEnhancedTSEnabled">
          <h2 class="mb-0 font-16 font-bold tire-heading">
            Tire {{index + 1}}
          </h2>
        </div>

        <div class="col-6 pl-0" *ngIf="isEnhancedTSEnabled">
          <h2 class="mb-0 font-16 font-bold tire-heading" *ngIf="size?.tirePosition">
            {{size?.tireHeaderTitle}}
          </h2>
          <h2 class="mb-0 font-16 font-bold tire-heading" *ngIf="!size?.tirePosition">
            Tire {{index + 1}}
          </h2>
        </div>

        <div class="col-6 content-end p-right-28" *ngIf="!isEnhancedTSEnabled">
          <i class="far fa-trash height-icon trash-danger" *ngIf="!_tire?.isInStorage"
            (click)="$event.stopPropagation();handleDeleteSize()"></i>
        </div>

        <div class="col-6 content-end p-right-28" *ngIf="isEnhancedTSEnabled">
          <button (click)="$event.stopPropagation();handleDuplicateSize(size)"
            [disabled]="disabledDuplicate || _tire?.isInStorage"
            [ngClass]="{'not-allowed': disabledDuplicate || _tire?.isInStorage}"
            class="btn btn-duplicate-primary btn-submit font-600 font-14">
            <i class="far fa-copy"></i>
            Duplicate
          </button>

          <button (click)="$event.stopPropagation();handleDeleteSize()" *ngIf="!_tire?.isInStorage"
            class="btn btn-delete-danger btn-submit font-600 font-14 ml-2">
            <i class="far fa-trash height-icon trash-danger"></i>
            Delete
          </button>

        </div>
      </div>
    </p-header>

    <div class="tire-size-wrapper ui-g">
      <!-- Tire Storage enhancement section -->
      <ng-container *ngIf="isEnhancedTSEnabled">
        <!-- first row -->
        <div class="input-basic-info-wrapper input-default-style ui-g-12 p-0">
          <div class="flex-row p-0 input-control-container">
            <!-- tire storage Enhancement brand -->
            <div class="tire-storage-info-width p-0 flex-start-center">
              <div class="icon flex-center-start">
                <i class="far fa-copyright height-icon"></i>
              </div>

              <div class="width-100p pl-1 pr-2">
                <app-auto-complete placeholder="Brand" label="Brand" scrollHeight="198px" editFieldLabel="Create brand"
                  tooltipPosition="top" editableItemIdKey="_id" editFieldPlaceholder="Create brand" [fontSize]="14"
                  [theme]="errors?.brand? 'primary' : 'light'" [floatingLabel]="true" [value]="size?.brand?.name"
                  [isInvalid]="errors?.brand" [hasError]="errors?.brand" [listItemFontSize]="14"
                  [isSaveForFuture]="true" [hasFutureSelectionField]="false" [isDropdownIconVisible]="true"
                  [suggestions]="tagsSuggestion" [disabled]="false"
                  [hasEditableField]="true" (appCompletedMethod)="handleTagSearch($event)" (appClear)="handleClear()"
                  (appSelect)="handleChange($event, 'brand')" (appSave)="handleCreateBrand($event)"
                  (appUpdateItem)="onUpdateItem($event, 'brand')">
                  <ng-template let-item let-editItem="editItem" appTemplate="item">
                    <div class="tag-item flex-between-center">
                      <div>
                        <span>{{ item?.name }}</span>
                      </div>
                      <div class="tag-item-action flex-end-center">
                        <i class="fas fa-pencil p-1 mr-2" (click)="$event.stopPropagation(); editItem(item)"></i>
                      </div>
                    </div>
                  </ng-template>
                </app-auto-complete>
              </div>
            </div>

            <!-- tire storage Enhancement model -->
            <div class="tire-storage-info-width p-0 flex-start-center">
              <div class="icon flex-center-start">
                <i class="far fa-tire height-icon"></i>
              </div>
              <div class="tire-category width-100p pl-1 pr-2">
                <app-input placeholder="Model" tooltipPosition="top" [disabled]="false"
                  [theme]="errors?.model? 'primary' : 'light'"
                  [floatingLabel]="true" [isInvalid]="errors?.model" [value]="size?.model"
                  (appChange)="handleChange($event, 'model')" (appFocus)="handleFocus('model')">
                </app-input>
              </div>
            </div>

            <!-- tire storage enhancement Size-->
            <div class="tire-storage-info-width p-0 flex-start-center">
              <div class="icon flex-center-start">
                <i class="far fa-align-justify height-icon"></i>
              </div>
              <div class="tire-category width-100p pl-1 pr-2">
                <app-input placeholder="Size" tooltipPosition="top" [disabled]="false"
                  [theme]="errors?.size? 'primary' : 'light'"
                  [floatingLabel]="true" [isInvalid]="errors?.size" [value]="size?.size"
                  (appChange)="handleChange($event, 'size')" (appFocus)="handleFocus('size')">
                </app-input>
              </div>
            </div>

            <!-- tire storage enhancement seaonality -->
            <div class="tire-storage-info-width p-0 flex-start-center">
              <div class="icon flex-center-start">
                <i class="far fa-sun-cloud height-icon"></i>
              </div>

              <div class="width-100p pl-1 pr-2">
                <app-dropdown id="tire-Seasonality" listId="tire-Seasonality-list" theme="primary" label="Seasonality"
                  [disabled]="false" tooltipPosition="top"
                  styleClass="pl-0" styleClassSelectedView="pl-0" [isDropdownIconVisible]="true"
                  styleClassLabel="left-0" placeholder="Seasonality" [floatingLabel]="true" [fontSize]="14"
                  [value]="size?.seasonality" [options]="sesonalityOptions"
                  (appSelect)="handleChange($event, 'seasonality')"></app-dropdown>
              </div>
            </div>

            <!-- tire Enehnacement part No -->
            <div class="tire-storage-info-width p-0 flex-start-center">
              <div class="icon flex-center-start">
                <i class="far fa-file-alt height-icon"></i>
              </div>
              <div class="tire-category width-100p pl-1 pr-2">
                <app-input placeholder="Part number" tooltipPosition="top" [disabled]="false"
                  [theme]="errors?.partNumber? 'primary' : 'light'"
                  [floatingLabel]="true" [isInvalid]="errors?.partNumber" [value]="size?.partNumber"
                  (appChange)="handleChange($event, 'partNumber')" (appFocus)="handleFocus('partNumber')">
                </app-input>
              </div>
            </div>
          </div>
        </div>
        <!-- second row -->
        <div class="input-basic-info-wrapper input-default-style ui-g-12 p-0">
          <div class="flex-row p-0 input-control-container">
            <!-- tire position -->
            <div class="tire-storage-info-width p-0 flex-start-center">
              <div class="icon flex-center-start">
                <i class="far fa-th-large height-icon"></i>
              </div>

              <div class="width-100p pl-1 pr-2">
                <app-dropdown id="tire-position" listId="tire-position-list" theme="primary" label="Tire position"
                  styleClass="pl-0" styleClassSelectedView="pl-0" [isDropdownIconVisible]="true"
                  [hasError]="errors?.tirePosition" styleClassLabel="left-0" placeholder="Tire position"
                  [floatingLabel]="true" [fontSize]="14" [value]="size?.tirePosition" [options]="tirePositionOptions"
                  (appSelect)="handleChange($event, 'tirePosition', true)"></app-dropdown>
              </div>
            </div>

            <!-- stogare location -->
            <div class="tire-storage-info-width p-0 flex-start-center">
              <div class="icon flex-center-start">
                <i class="far fa-warehouse height-icon"></i>
              </div>

              <div class="width-100p pl-1 pr-2">
                <app-auto-complete id="tire-storage-location" listId="tire-storage-location-list" itemWidth="225px"
                  label="Storage location*" placeholder="Storage location" field="name" scrollHeight="180px"
                  theme="light" editableItemIdKey="locationId" editFieldLabel="Create storage location"
                  [floatingLabel]="true" [hasEditableField]="true" [hasFutureSelectionField]="false"
                  [closeOnSelection]="true" [isDropdownIconVisible]="true" [hasStaticUnassignedFiled]="false"
                  [suggestions]="locationResults" [listItemFontSize]="14" [fontSize]="14" [disabled]="estimateOrderStatus === 'invoice'"
                  [value]="size?.storageLocation?.name" editFieldPlaceholder="Create brand"
                  (appUpdateItem)="onStorageLocationUpdate($event)"
                  (appSelect)="handleChange($event, 'storageLocation')" (appSave)="onStorageLocationSave($event)"
                  [isSaveForFuture]="true" (appCompletedMethod)="onStorageLocationSearch($event)"
                  (appClear)="onStorageLocationClear()">
                  <ng-template let-item let-editItem="editItem" appTemplate="item">
                    <div class="tag-item flex-between-center">
                      <div>
                        <span>{{ item?.name }}</span>
                      </div>
                      <div class="tag-item-action flex-end-center">
                        <i class="fas fa-pencil p-1 mr-2" (click)="$event.stopPropagation(); editItem(item)"></i>
                      </div>
                    </div>
                  </ng-template>

                </app-auto-complete>
              </div>
            </div>

            <!-- tread depth -->
            <div class="tire-storage-info-width p-0 flex-column">
              <div class="flex-start-center">
                <div class="icon flex-center-start">
                  <i class="far fa-ruler height-icon"></i>
                </div>

                <div class="position-relative width-100p pl-1 pr-2">
                  <app-input placeholder="Tread depth" theme="light" [mask]="!size?.oldTreadDepth? '00': ''"
                    [floatingLabel]="true" suffix="{{size?.oldTreadDepth? '' : '/32'}}"
                    [theme]="errors?.treadDepth? ' primary' : 'light'" [isInvalid]=" errors?.treadDepth"
                    [errorMessage]="errors?.treadDepth" [value]="size.treadDepth"
                    (appChange)="handleChange($event, 'treadDepth')" (appBlur)="handleBlurForTreadDepth('treadDepth')"
                    (appFocus)="handleFocus('treadDepth')"></app-input>
                  <i class="tread-depth-info fal fa-info-circle" *ngIf="size?.oldTreadDepth" tooltipPosition="bottom"
                    pTooltip="This data is based on older input methods. For accuracy, please use the 'n/32' format, where 'n' is a number between 1 and 32."></i>
                </div>
              </div>
            </div>

            <!-- rim type -->
            <div class="tire-storage-rim-width p-0 flex-start-center">
              <div class="icon flex-center-start">
                <i class="far fa-align-justify height-icon"></i>
              </div>

              <div class=" width-100p pl-1 pr-2">
                <app-dropdown placeholder="Rim type" field="name" [theme]="errors?.rimType? 'primary' : 'light'"
                  [floatingLabel]="true" [value]="size?.rimType" [isDropdownIconVisible]="true" [options]="rimTypes"
                  [fontSize]="14" [listItemFontSize]="14" (appSave)="handleRimTypeSave($event)"
                  (appSelect)="handleChange($event, 'rimType')"></app-dropdown>
              </div>
            </div>

            <!-- tire Label -->
            <div class="tire-storage-info-width p-0 flex-start-center">
              <div class="icon flex-center-start">
                <i class="far fa-tags height-icon"></i>
              </div>

              <div class="width-100p pl-1 pr-2">
                <app-input placeholder="Tire label" theme="light" [floatingLabel]="true" theme="light"
                  tooltipPosition="bottom" [pTooltip]="size?.tireLabel" [value]="size?.tireLabel"
                  (appChange)="handleChange($event, 'tireLabel')"></app-input>
              </div>
            </div>
          </div>
        </div>

        <!-- third row -->
        <div class="input-basic-info-wrapper input-default-style ui-g-12 p-0 tire-recommend-row">
          <div class="flex-row p-0 input-control-container">
            <!-- recommend tire replacement -->
            <div class="flex-start-end p-0 tire-storage-recommend-width">
              <div class="pl-1 pr-2 width-100p">
                <app-checkbox inputId="tire-info-recommendation-{{index}}" label="Recommend tire replacement"
                  [isChecked]="size.recommendReplacement" (appChange)="handleChange($event, 'recommendReplacement')">
                </app-checkbox>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Tire storage enhancement section ends -->
      <ng-container *ngIf="!isEnhancedTSEnabled">
        <!-- Basic Info section -->
        <div class="input-basic-info-wrapper input-default-style ui-g-12 p-0">
          <div class="ui-g-12 p-0 input-control-container">

            <div class="ui-g-4 p-0 flex-start-center">
              <div class="icon flex-center-start m-neg-left-10">
                <i class="far fa-warehouse height-icon"></i>
              </div>

              <div class="width-100p p-left-14 pr-2">
                <app-auto-complete id="tire-storage-location" listId="tire-storage-location-list"
                  label="Storage location*" placeholder="Storage location" field="name" scrollHeight="180px"
                  theme="light" editableItemIdKey="locationId" editFieldLabel="Create storage location"
                  [floatingLabel]="true" [hasEditableField]="true" [hasFutureSelectionField]="false"
                  [closeOnSelection]="true" [isDropdownIconVisible]="true" [hasStaticUnassignedFiled]="false"
                  [suggestions]="locationResults" [listItemFontSize]="14" [fontSize]="14"
                  [value]="size?.storageLocation?.name" editFieldPlaceholder="Create brand"
                  (appUpdateItem)="onStorageLocationUpdate($event)"
                  (appSelect)="handleChange($event, 'storageLocation')" (appSave)="onStorageLocationSave($event)"
                  [isSaveForFuture]="true" (appCompletedMethod)="onStorageLocationSearch($event)"
                  (appClear)="onStorageLocationClear()">
                  <ng-template let-item let-editItem="editItem" appTemplate="item">
                    <div class="tag-item flex-between-center">
                      <div>
                        <span>{{ item?.name }}</span>
                      </div>
                      <div class="tag-item-action flex-end-center">
                        <i class="fas fa-pencil p-1 mr-2" (click)="$event.stopPropagation(); editItem(item)"></i>
                      </div>
                    </div>
                  </ng-template>

                </app-auto-complete>
              </div>
            </div>

            <div class="ui-g-4 p-0 flex-start-center">
              <div class="icon flex-center-start">
                <i class="far fa-tire height-icon"></i>
              </div>

              <div class=" width-100p pl-1 pr-2">
                <app-input placeholder="Tire label" theme="light" [floatingLabel]="true"
                  [theme]="errors?.tireLabel? 'primary' : 'light'" [isInvalid]="errors?.tireLabel"
                  [value]="size.tireLabel" (appChange)="handleChange($event, 'tireLabel')"
                  (appFocus)="handleFocus('tireLabel')"></app-input>
              </div>
            </div>

            <div class="ui-g-4 p-0 flex-start-center">
              <div class="icon flex-center-start">
                <i class="far fa-align-justify height-icon"></i>
              </div>

              <div class=" width-100p pl-1 pr-2">
                <app-dropdown placeholder="Rim type" field="name" [theme]="errors?.rimType? 'primary' : 'light'"
                  [floatingLabel]="true" [value]="size?.rimType" [isDropdownIconVisible]="true" [options]="rimTypes"
                  [fontSize]="14" [listItemFontSize]="14" (appSave)="handleRimTypeSave($event)"
                  (appSelect)="handleChange($event, 'rimType')"></app-dropdown>
              </div>
            </div>
          </div>
        </div>
        <!-- Basic info section ends -->

        <!-- Pricing section -->
        <div class="input-basic-info-wrapper input-default-style ui-g-12 p-0">
          <div class="ui-g-12 p-0 input-control-container">
            <div class="ui-g-4 p-0 flex-start-center">
              <div class="icon flex-center-start m-neg-left-10">
                <i class="far fa-qrcode height-icon"></i>
              </div>

              <div class="width-100p pr-2 p-left-14">
                <app-input placeholder="Tread depth" theme="light" [floatingLabel]="true"
                  [theme]="errors?.treadDepth? 'primary' : 'light'" [isInvalid]="errors?.treadDepth"
                  [value]="size.treadDepth" (appChange)="handleChange($event, 'treadDepth')"
                  (appFocus)="handleFocus('treadDepth')"></app-input>
              </div>
            </div>

            <div class="ui-g-6 p-0 flex-start-center m-top-10">
              <div class="width-100p pr-2">
                <div class="width-100p pl-1 pr-2 position-relative cost-field">
                  <app-checkbox inputId="tire-info-recommendation-{{index}}" label="Recommend tire replacement"
                    [isChecked]="size.recommendReplacement" (appChange)="handleChange($event, 'recommendReplacement')">
                  </app-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

    </div>
  </p-accordionTab>
</p-accordion>
